import React, { useState, useEffect, useContext, useRef } from 'react';
import Dialog from '../DefaultDialog';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import PinOnMap from '../PinOnMap';
import SelectCity from '../../FormInputs/SelectCity';
import { toEN, checkMobilePhone } from '../../../fns';
import MainContext from '../../../store/MainContext';
import { FormHelperText } from '@material-ui/core';
import neshan from '../../../api/neshan';
import axios from '../../../api/axios';
import ListAddresses from './ListAddresses';
import AddBoxRoundedIcon from '@material-ui/icons/AddBoxRounded';
import normalizeMobile from '../../../fns/normalizeMobile';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import { makeStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles((theme) => ({
  addressType: {
    display: 'flex',
    flexFlow: 'row nowrap',
    '& > *:not(:last-child)': {
      marginLeft: theme.spacing(1),
    },
  },
}));

const SelectAddress = ({
  addressType = null,
  address,
  onClose,
  onSave,
  order,
  _customer,
}) => {
  const classes = useStyles();
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [newForm, setNewForm] = useState(false);
  const [position, setPosition] = useState(null);
  const [marker, setMarker] = useState(null);
  const [openPin, setOpenPin] = useState(false);
  const [cityName, setCityName] = useState(null);
  const [addresses, setAddresses] = useState(null);
  const [loadingAddress, setLoadingAddress] = useState(false);
  const [search, setSearch] = useState('');
  const addressField = useRef(null);
  const { showMessage, showError } = useContext(MainContext);
  let customer = _customer ? _customer : order.customer;
  const handleSetMarker = (marker) => {
    setMarker(marker);
  };
  const handleSetPosition = (position) => {
    setPosition(position);
  };
  const handleCloseDialog = () => {
    onClose();
  };
  const validateForm = () => {
    let error = {};
    !values.city && (error.city = 'شهر بایستی انتخاب شود.');
    !values.details && (error.details = 'آدرس بایستی وارد شود');
    (!values.transferee || values.transferee.length < 3) &&
      (error.transferee = 'نام و نام خانوادگی هماهنگ کننده را وارد کنید.');
    return error;
  };
  const handleCloseAndSaveDialog = async (addToFave = false) => {
    const error = validateForm();
    if (Object.entries(error).length > 0) {
      showError('لطفا موارد مشخص شده را اصلاح فرمایید.');
      setErrors(error);
    } else {
      const {
        city,
        transferee,
        details,
        mobilePhone,
        zipcode,
        nationalCode,
        companyNationalCode,
        addressType: _addressType,
      } = values;

      var address = {
        city,
        transferee,
        details,
        mobilePhone,
        nationalCode,
        companyNationalCode,
        addressType: _addressType,
        zipcode,
      };

      if (addToFave) {
        const _address = {
          owner: order ? order.customer._id : customer._id,
          city: city._id,
          transferee,
          details,
          mobilePhone,
          location: {
            type: 'Point',
            coordinates: marker ? marker : city.location.coordinates,
          },
          nationalCode,
          companyNationalCode,
          addressType: _addressType,
          zipcode,
        };
        try {
          setLoadingAddress(true);
          const {
            data: { messages, addressId },
          } = await axios.post(`/api/v1/admin/users/addFavoriteAddress`, {
            customerId: order ? order.customer._id : customer._id,
            address: _address,
          });
          showMessage(messages);
          address._id = addressId;
        } catch (error) {
          showError(error);
        } finally {
          setLoadingAddress(false);
        }
      }

      marker &&
        (address.location = {
          type: 'Point',
          coordinates: marker,
        });
      onSave({ addressType, address });
    }
  };
  const handleOpenSelectLocation = () => {
    setOpenPin(true);
  };
  const handleCloseSelectLocation = () => {
    setOpenPin(false);
  };
  const handleChange = (e) => {
    let { name, value } = e.target;
    if (name === 'mobilePhone') {
      value = toEN(value);
      value = checkMobilePhone(value) ? checkMobilePhone(value) : value;
    }
    setValues({ ...values, [name]: value });
  };
  const getAddressTextFromNeshan = async () => {
    try {
      const { data } = await neshan.get(
        `/v2/reverse?lat=${marker[0]}&lng=${marker[1]}`
      );
      data &&
        data.formatted_address &&
        setValues({ ...values, details: data.formatted_address });
      data?.city && setCityName(data.city);
    } catch (error) {
      console.error(JSON.stringify(error, null, 2));
    }
  };
  const handleSelectAddressFromList = (address) => {
    onSave({ addressType, address });
  };
  const handleNewForm = () => {
    setNewForm(true);
    delete values._id;
    setValues({ ...values });
  };
  const handleDeleteAddress = async (id) => {
    try {
      const {
        data: { addresses },
      } = await axios.delete(
        `/api/v1/admin/users/deleteFavoriteAddress/${
          order ? order.customer._id : customer._id
        }/${id}`
      );
      addresses && setAddresses(addresses);
    } catch (error) {
      showError(error);
    }
  };
  const handleChangeSearch = (e) => {
    const { value } = e.target;
    setSearch(value);
  };
  const handleCopyAddress = () => {
    const a = addressField.current;
    a.querySelector('textarea').select();
    document.execCommand('copy');
    alert('کپی شد!');
  };

  useEffect(() => {
    marker && getAddressTextFromNeshan();
  }, [marker]);
  useEffect(() => {
    address && setValues({ ...address });
  }, [address]);
  useEffect(() => {
    setValues((prev) => {
      let v = {
        ...prev,
        transferee: `${
          customer?.legal
            ? `شرکت ${customer.company}`
            : `${customer?.firstName || ''} ${customer?.lastName || ''}`
        }`,
        mobilePhone: customer?.mobilePhone
          ? normalizeMobile(customer.mobilePhone)
          : '',
        zipcode: customer?.zipcode || '',
      };
      customer?.legal
        ? (v.companyNationalCode = customer?.companyNationalCode || '')
        : (v.nationalCode = customer?.nationalCode || '');
      addressType ? (v.addressType = addressType) : (v.addressType = 'none');
      return v;
    });
    const customerId = order ? order.customer._id : customer._id;
    (async () => {
      try {
        const {
          data: { addresses },
        } = await axios.get(
          `/api/v1/admin/users/${customerId}/favoriteAddresses?addressType=${
            addressType ? addressType : 'none'
          }${search ? `&cityName=${search}` : ''}`
        );

        setAddresses(addresses);
      } catch (error) {
        showError(error);
      }
    })();
  }, [customer, order, search, addressType]);
  return (
    <>
      <Dialog
        save={addressType ? 'انتخاب' : false}
        cancel="صرفنظر"
        title={`محل ${
          addressType === 'origin'
            ? 'بارگیری'
            : addressType === 'destination'
            ? 'تخلیه'
            : 'انبارها'
        }`}
        open={true}
        onSave={handleCloseAndSaveDialog}
        onClose={handleCloseDialog}
        extraButtons={
          newForm ? (
            <Button
              color="secondary"
              variant="contained"
              disabled={loadingAddress}
              onClick={() => handleCloseAndSaveDialog(true)}
            >
              {addressType ? `ذخیره آدرس برای مشتری و انتخاب` : `ذخیره آدرس`}
            </Button>
          ) : null
        }
      >
        <Grid container direction="column" spacing={1}>
          {newForm ? (
            <>
              <Grid item>
                <Button
                  fullWidth
                  size="small"
                  variant="contained"
                  color="default"
                  startIcon={<LocationOnOutlinedIcon />}
                  onClick={handleOpenSelectLocation}
                >
                  {`تعیین لوکیشن ${
                    addressType === 'origin'
                      ? 'بارگیری'
                      : addressType === 'destination'
                      ? 'تخلیه'
                      : 'انبار'
                  } و آدرس از روی نقشه`}
                </Button>
              </Grid>
              <Grid item>
                <SelectCity
                  city={values.city ? values.city : null}
                  onSelect={(city) => {
                    setValues({ ...values, city });
                    city && setPosition(city.location.coordinates);
                  }}
                  isMulti={false}
                  cityName={cityName}
                />
                <FormHelperText error>
                  {errors.city ? errors.city : ''}
                </FormHelperText>
              </Grid>
              <Grid item>
                <TextField
                  label={`آدرس ${
                    addressType === 'origin' ? 'محل بارگیری' : 'محل تخلیه'
                  }`}
                  name="details"
                  value={values.details ? values.details : ''}
                  multiline
                  rows={4}
                  variant="outlined"
                  size="small"
                  onChange={handleChange}
                  fullWidth
                  helperText={errors.details ? errors.details : ''}
                  error={errors.details ? true : false}
                />
              </Grid>
              <Grid item>
                <TextField
                  label="نام و نام خانوادگی هماهنگ کننده"
                  value={values.transferee ? values.transferee : ''}
                  fullWidth
                  name="transferee"
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  helperText={errors.transferee ? errors.transferee : ''}
                  error={errors.transferee ? true : false}
                />
              </Grid>
              <Grid item>
                <TextField
                  label="شماره تماس هماهنگ کننده"
                  value={
                    values.mobilePhone
                      ? normalizeMobile(values.mobilePhone)
                      : ''
                  }
                  fullWidth
                  name="mobilePhone"
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item>
                <TextField
                  label={customer?.legal ? 'شناسه ملی شرکت' : 'کد ملی'}
                  value={
                    customer?.legal
                      ? values?.companyNationalCode || ''
                      : values?.nationalCode || ''
                  }
                  fullWidth
                  name={
                    customer?.legal ? `companyNationalCode` : `nationalCode`
                  }
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item>
                <TextField
                  label="کد پستی"
                  value={values?.zipcode || ''}
                  fullWidth
                  name="zipcode"
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              {
                <Grid item>
                  <FormLabel component="legend">نوع آدرس:</FormLabel>
                  <RadioGroup
                    name="addressType"
                    value={values?.addressType || 'none'}
                    onChange={handleChange}
                    className={classes.addressType}
                  >
                    <FormControlLabel
                      value="none"
                      control={<Radio />}
                      label="نامشخص"
                    />
                    <FormControlLabel
                      value="origin"
                      control={<Radio />}
                      label="محل بارگیری"
                    />
                    <FormControlLabel
                      value="destination"
                      control={<Radio />}
                      label="محل تخلیه"
                    />
                  </RadioGroup>
                </Grid>
              }
            </>
          ) : (
            <>
              {address && (
                <TextField
                  value={`${
                    address?.city?.state?.title
                      ? `${address.city.state.title}`
                      : ''
                  } ${address?.city?.title ? `، ${address.city.title}` : ''} ${
                    address?.details ? ` - آدرس: ${address.details}` : ''
                  } ${address?.transferee ? ` - ${address.transferee}` : ''} ${
                    address?.mobilePhone ? ` - ${address.mobilePhone}` : ``
                  } ${
                    address?.zipcode ? ` - کدپستی: ${address.zipcode}` : ``
                  } ${
                    address?.nationalCode
                      ? ` - کدملی:${address?.nationalCode}`
                      : ``
                  } ${
                    address?.companyNationalCode
                      ? ` - شناسه ملی شرکت:${address.companyNationalCode}`
                      : ``
                  }`}
                  multiline
                  onChange={null}
                  style={{ marginBottom: 10 }}
                  ref={addressField}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleCopyAddress}>
                          <FileCopyIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
              <TextField
                label="نام شهر"
                variant="outlined"
                size="small"
                style={{ marginBottom: 10 }}
                value={search || ''}
                onChange={handleChangeSearch}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                startIcon={<AddBoxRoundedIcon />}
                size="small"
                variant="contained"
                color="primary"
                onClick={handleNewForm}
              >
                افزودن آدرس جدید برای مشتری
              </Button>
              <ListAddresses
                addresses={addresses}
                onClick={handleSelectAddressFromList}
                onDelete={handleDeleteAddress}
              />
            </>
          )}
        </Grid>
      </Dialog>
      {openPin && (
        <PinOnMap
          open={openPin}
          position={position}
          marker={marker}
          setMarker={handleSetMarker}
          setPosition={handleSetPosition}
          onClose={handleCloseSelectLocation}
        />
      )}
    </>
  );
};

export default SelectAddress;
